module.exports = __webpack_public_path__ + "img/Icon-Twitter.8390c68c.png";